import { useGetLoggedInUserQuery } from '../redux/api/users';

/**
 * Both spellings exist. The move API accepts either, via
 * INTERNAL_ORDERS_MANAGE_GROUPS, and a manager in the singular group would
 * otherwise not see Move.
 */
const SHOP_MANAGER_GROUPS = ['Shop Managers', 'Shop Manager'];

/**
 * Returns whether the currently logged-in user is a Shop Manager (or superuser).
 *
 * - `isShopManager === undefined` → still loading
 * - `isShopManager === true`      → has write access to location models
 * - `isShopManager === false`     → read-only; write attempts should show a permission warning
 */
export const useIsShopManager = (): { isShopManager: boolean | undefined; isLoading: boolean } => {
	const { data: user, isLoading } = useGetLoggedInUserQuery();
	const isShopManager = user
		? user.is_superuser === true ||
			(user.groups ?? []).some((group) => SHOP_MANAGER_GROUPS.includes(group))
		: undefined;
	return { isShopManager, isLoading };
};

export default useIsShopManager;
